module.exports = __webpack_public_path__ + "img/4_3.0c04efc4.png";